// extracted by mini-css-extract-plugin
export var activityContainer = "_nq-0";
export var typingIndicatorContainer = "_nq-1";
export var typingIndicatorDot = "_nq-2";
export var wave = "_nq-3";